<form [formGroup]="form" [softMetaForm]="metaForm()">
  <div class="flex flex-row">
    @for (item of items(); track item; let i = $index) {
      <div
        [softMetaControlName]="item.key"
        class="mr-2 px-4"
        [class]="i === items().length - 1 ? '' : 'border-r'"
      >
        <soft-meta-query-bar-item
          [meta]="item.meta"
          [name]="item.key"
          [formControlName]="item.key"
        ></soft-meta-query-bar-item>
      </div>
    }
  </div>
</form>
